import { FC } from 'react';
import styled from 'styled-components';
import { CssOutput } from '@lmn/design-system';
import { Paragraph } from '../atoms/paragraph';

const LegalDisclaimerContainer = styled(Paragraph)`
  color: ${({ theme }): string => theme.commons.colors.gray300};
  ${({ theme }): CssOutput => theme.mixins.font('TextSmall')};
  text-align: center;
`;

export const LegalDisclaimer: FC = () => (
  <LegalDisclaimerContainer>
    The postings on this site are authors&apos; opinions and experiences and do not necessarily represent the postings,
    strategies or opinions of lastminute.com group.
  </LegalDisclaimerContainer>
);
